import { Link } from "@tanstack/react-router";
import { useLanguage } from "@/i18n/LanguageProvider";
import logoSrc from "@/assets/logo.png";

export function Logo() {
  const { t } = useLanguage();
  return (
    <Link to="/" className="flex items-center group">
      <img
        src={logoSrc}
        alt={t.brand}
        className="h-16 w-auto object-contain transition-transform"
      />
    </Link>
  );
}
